/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_MultideckInputs */



/**
* | output |
* | --- |
* | "Multideck" |
*
* @param {Tfield_MultideckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_multideck = /** @type {((inputs?: Tfield_MultideckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_MultideckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Multi-deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Multideck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Multideck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Multideck")
	return /** @type {LocalizedString} */ ("Multideck")
});